/*!
 * CMS
 * --
 * Instructions:
 * # (important) if you don't know what it's going on in this code, close the project and ask for help.
 * # (required) drink 2 four lokos (gold and black)
 * # (required) listen the next song 24/7:
 *  - https://soundcloud.com/neonkidoficial/the-less-i-know-the-better-vs-sexy-back-neon-kid-mashup
 * # repeat the song, over and over.
 * # start coding.
 * # KISS.
 */
import 'overlayscrollbars/css/OverlayScrollbars.css';
import 'leaflet/dist/leaflet.css';
import './stylus/main.scss';
import 'leaflet/dist/leaflet.css';
import Vue from 'vue';
import axios from 'axios';
import Graph from '@@';
import vuetify from '@/plugins/vuetify';
import i18n from '@/plugins/i18n';
import masonry from '@/plugins/masonry';
import router from '@/routes/router';
import store from '@/store';
import App from '@/App.vue';
//import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { waiter, getStorageUser } from '@@/helpers';
import './components';
import moment from 'moment-timezone';

Vue.config.devtools = true
Vue.config.productionTip = true

// We need to set the schema into the store to make a check of this before the
// main Vue instance it's created, to accomplish this we need to set the schema
// in the store or another state management (the store is already installed so
// we use it). If we try to access the schema of the main instance of Vue, this
// is going to be undefined cuz the main instance it's not created already.
Graph.boot(axios, { schema: true }).then(async (GraphPlugin) => {
  Vue.use(GraphPlugin, { store, router })

  // TODO: make a storage module for prefixing, and storage management.
  const userData = getStorageUser();
  // TODO: ...
  // If it's different from null set the token and save the user info into the
  // state management system (Vuex).
  if (!isEmpty(userData)) {
    moment.tz.setDefault(userData.user.ianaTimeZone);
    store.commit('USER', userData);
    // Get the user configuration and save it into the store for future referencing.
    const [{ data: config }] = await waiter(axios.get(`user/configuration/${userData.user.uid}`));
    store.commit('CONFIG', config);
  }
  window.$app = new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
  }).$mount('#app')
})
